<template>
  <login-form-container>
    <div class="account-content mx-3">
      <div v-if="!verifiedSuccessfully && hashIsValid">
        <div class="text-center my-3">
          <p class="text-muted">
            {{ trans("auth.verifyLabel") }}
          </p>
        </div>

        <div v-if="generalError !== ''" class="alert alert-danger">
          {{ generalError }}
        </div>

        <form class="form-horizontal" @submit.prevent="submitVerifyData()">
          <div class="form-group" :class="{ 'has-error': username.hasErrors }">
            <div class="col-xs-12">
              <label for="username">{{ trans("users.usernameLabel") }}</label>
              <input
                id="username"
                v-model="username.value"
                type="username"
                class="form-control"
                name="username"
                required
                autofocus
              />
              <small class="form-text text-muted">{{
                trans("auth.recommendedUsernameLength")
              }}</small>

              <span v-if="username.hasErrors" class="help-block">
                <strong>{{ username.errorMessage }}</strong>
              </span>
            </div>
          </div>

          <div class="form-group" :class="{ 'has-error': password.hasErrors }">
            <div class="col-xs-12">
              <label for="password">{{
                trans("auth.resetPasswordInputLabelPassword")
              }}</label>
              <input
                id="password"
                v-model="password.value"
                type="password"
                class="form-control"
                name="password"
                required
              />
              <small class="form-text text-muted">{{
                trans("auth.recommendedPasswordLength")
              }}</small>

              <span v-if="password.hasErrors" class="help-block">
                <strong>{{ password.errorMessage }}</strong>
              </span>
            </div>
          </div>

          <div
            class="form-group mb-4"
            :class="{ 'has-error': passwordConfirm.hasErrors }"
          >
            <div class="col-xs-12">
              <label for="password-confirm">{{
                trans("auth.resetPasswordInputLabelPasswordConfirm")
              }}</label>
              <input
                id="password-confirm"
                v-model="passwordConfirm.value"
                type="password"
                class="form-control"
                name="password_confirmation"
                required
              />

              <span v-if="passwordConfirm.hasErrors" class="help-block">
                <strong>{{ passwordConfirm.errorMessage }}</strong>
              </span>
            </div>
          </div>

          <div class="form-group account-btn text-center">
            <div class="col-md-12">
              <clip-loader v-show="loading" />
              <button
                v-if="!loading"
                type="submit"
                class="btn btn-custom btn-block btn-lg"
              >
                {{ trans("auth.verifyAccountInputLabel") }}
              </button>
            </div>
            <div class="col-md-12 mt-2">
              <router-link to="/auth" class="btn btn-grey btn-block btn-lg">
                {{ trans("auth.forgotPasswordBackButton") }}
              </router-link>
            </div>
          </div>
        </form>

        <div class="clearfix" />
      </div>

      <div v-if="verifiedSuccessfully" class="text-center my-4">
        {{ trans("auth.verifyAccountSuccess") }}
      </div>

      <div
        v-if="generalError != '' && !hashIsValid"
        class="alert alert-danger text-center my-4"
      >
        {{ generalError }}
      </div>

      <div
        v-if="!hashIsValid && !loading"
        class="alert alert-warning text-center my-4"
      >
        {{ trans("auth.verifyHashInvalid") }}
      </div>
    </div>
  </login-form-container>
</template>

<script>
import LoginFormContainer from "./LoginFormContainer.vue";
import { lang } from "../../i18n";

export default {
  components: {
    LoginFormContainer,
  },
  data() {
    return {
      loading: true,
      success: false,
      generalError: "",
      username: {
        value: "",
        hasErrors: false,
        errorMessage: "",
        successMessage: "",
      },
      password: {
        value: "",
        hasErrors: false,
        errorMessage: "",
      },
      passwordConfirm: {
        value: "",
        hasErrors: false,
        errorMessage: "",
      },
      verifiedSuccessfully: false,
      hashIsValid: false,
    };
  },
  mounted: function () {
    var instance = this;
    axios
      .get(
        "/api/internal/auth/verification/verify-hash/" +
          instance.$route.params.id +
          "/" +
          instance.$route.params.hash,
      )
      .then((response) => {
        instance.loading = false;
        instance.hashIsValid = response.data.valid;
        lang.setLocale(response.data.language);
      })
      .catch(function (error) {
        instance.generalError = instance.trans("errorMessages.HTTPStatus.5XX");
        instance.userErrorMessage(error);
      });
  },
  methods: {
    submitVerifyData: function () {
      let instance = this;
      axios
        .post(
          "/api/internal/auth/verification/verify-account/" +
            instance.$route.params.id +
            "/" +
            instance.$route.params.hash,
          {
            username: instance.username.value,
            password: instance.password.value,
            password_confirmation: instance.passwordConfirm.value,
            id: instance.id,
            hash: instance.hash,
            lang_code: localStorage.getItem("lang_code", "en"),
          },
        )
        .then((response) => {
          instance.loading = false;
          instance.verifiedSuccessfully = true;
          setTimeout(
            function () {
              instance.$router.push({ name: "Auth" });
            },
            3000,
            instance,
          );
        })
        .catch(function (error) {
          let data = error.response?.data;

          if (error.response?.status === 500) {
            instance.generalError = instance.trans(
              "errorMessages.HTTPStatus.5XX",
            );
          }

          if (data) {
            if (data.error && data.error.general) {
              instance.generalError = data.error.general;
            }

            if (data.username) {
              instance.username.hasErrors = true;
              instance.username.errorMessage = data.username[0];
            } else {
              instance.username.hasErrors = false;
            }

            if (data.password) {
              instance.password.hasErrors = true;
              instance.passwordConfirm.hasErrors = true;
              instance.password.errorMessage = data.password[0];
            } else {
              instance.password.hasErrors = false;
              instance.passwordConfirm.hasErrors = false;
            }
          }

          instance.loading = false;
          instance.userErrorMessage(error);
        });
    },
  },
};
</script>
